export const operatingRegions = `
  operatingRegions {
    country
    countryCode
    region
    regionCode
  }
`;
